
import FileResultCard from './FileResultCard.vue';
import fileService from '@/services/ProjectFileService';
import MxInfoButton from '@/components/global/MxInfoButton.vue';
import MxModal from '@/components/global/MxModal.vue';
import FileSignatureStructure from './FileSignatureStructure.vue';
import FileEncoderConfigurationAnalysis from './FileEncoderConfigurationAnalysis.vue';
import FileStructuralSignatureSummary from './FileStructuralSignatureSummary.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { IFileEncoderConfigurationAnalysisResource, IFileExaminationResult, IFileGenerationHistory, IFileOriginatingDevice, SignatureMatchType, IFileSignature, IFileSignatureStructure, FileFlagStatus } from '@/types/resource.types';
import { fileResultTableheaders } from '@/components/projects/summary/ProjectSummaryFilesTable.vue';

@Component({
    name: 'FileOriginatingDevice',
    components: {
        FileResultCard,
        FileSignatureStructure,
        FileEncoderConfigurationAnalysis,
        FileStructuralSignatureSummary,
        MxModal,
        MxInfoButton
        
    }
})
export default class FileOriginatingDevice extends Vue {

    /* Props
    ============================================*/

    @Prop({type: Object, required: false})
    readonly eca: IFileEncoderConfigurationAnalysisResource;

    @Prop({type: Object, required: true})
    readonly fileResult: IFileExaminationResult;

    showModal: boolean = false;
    showStructModal: boolean = false;
    signature: IFileSignature | null = null;

    /* Methods
    ============================================*/
    async loadSignature() {
        if(!this.fileResult?.file?.id) return;
        try {
            this.signature = await fileService.getSignature(this.fileResult.file.id);
            this.showStructModal = true;
        } catch(e) {
            this.$logger.logError(e);
        }
    }

    showSummary() {
        this.showModal = !this.showModal;
    }
    /* Computed
    ============================================*/

    get lastGenerationCategory(): string {
        if(this.history?.lastGenerationCategory){
            return this.history.lastGenerationCategory;
        }
        return "Uncategorized"
    }
    get structures(): IFileSignatureStructure[] {
        return this.signature?.structures ?? [];
    }

    get device(): IFileOriginatingDevice | undefined {
        return this.fileResult?.originatingDevice;
    }

    get showMatches(): boolean {
        return !!this.fileResult?.matchHistory;
    }

    get embeddedModelDiscrepancy(): boolean {
        return this.fileResult?.file?.embeddedModelDiscrepancy ?? false;
    }
    get history(): IFileGenerationHistory | undefined {
        return this.fileResult?.generationHistory;
    }
    
    get hasMatch(): boolean {
        return this.device?.matchType === SignatureMatchType.FULL_MATCH
            || this.fileResult?.file?.signature1RefMatch === true;
    }

    get matchText(): string {
        return this.hasMatch ? 'Full Signature Match' : 'No Signature Match';
    }

    get matchType(): string {
        return this.hasMatch ? 'success' : '';
    }

    get matchEcaText(): string {
        if(this.eca?.type === 2) {
            return 'ECA Match';
        }
        return 'No ECA Match';
    }

    get matchEcaType(): string {
        if(this.eca?.type === 2) {
            return 'success';
        }
        return '';
    }
    get fileIsFlagged(): boolean {
        return this.fileResult?.file?.flagStatus === FileFlagStatus.Flagged;
    }
}

